<div class="flex-column h-100">
  <div class="configuration-wizard-header flex-column">
    <h5
      class="odx-title-5"
      i18n="@@patientMonitorConfiguration.selectProductFamily.header"
      data-testid="patientMonitorConfiguration.selectProductFamily.header"
    >
      {{ title }}
    </h5>

    <app-filter-product (searchEvent)="search($event)"></app-filter-product>
  </div>

  <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
    @if (filteredOptionDisplays$ | async; as optionDisplays) {
      @if (optionDisplays.length > 0) {
        <form [formGroup]="familyForm" class="h-100">
          <odx-radio-group formControlName="selectedFamily" required="true" class="h-100">
            <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36">
              @for (family of optionDisplays; track family.family?.familyNumber) {
                <app-monitoring-option-card
                  [option]="family"
                  [isSelected]="selectedFamily?.family?.familyNumber === family.family?.familyNumber"
                  [selectionMode]="StepSelectionType.PICK1"
                  [category]="category"
                  [categoryLabel]="categoryLabel"
                  (click)="select(family)"
                  (select$)="select(family)"
                >
                </app-monitoring-option-card>
              }
            </div>
          </odx-radio-group>
        </form>
      } @else if (refreshProductsDataType; as dataType) {
        <app-refresh-products-hint [dataType]="dataType"></app-refresh-products-hint>
      }
    }
  </odx-content-box>
</div>
